import React from "react";
import Cta from "@qlik/qlik/src/components/Cta";
import RichText from "@qlik/qlik/src/components/RichText";
import { getColorClassName } from "@qlik/qlik/src/lib/util/colors";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import * as styles from "./styles.module.css";
import { renderSanitizedHtmlContent } from "@qlik/qlik/src/lib/util/helpers";

const PricingPromo = ({ data }) => {
    const {
        title: sectionTitle,
        subtitle: sectionSubTitle,
        customId,
        cardItem,
        backgroundColor,
        cardItemBackgroundColor,
        backgroundImage,
        additionalConfiguration,
    } = data ?? {};
    const { title, description, body, cta } = cardItem ?? {};
    const sectionSpacingClassName = getSpacingClassName(additionalConfiguration);
    const { sectionColorMapping, cardColorMapping } = getColorClassName(backgroundColor, cardItemBackgroundColor);

    return (
        <section
            id={customId}
            data-section
            className={`scroll-mt-45 ${sectionSpacingClassName} ${sectionColorMapping.bgColor}`}
        >
            <div className="container">
                {(sectionTitle || sectionSubTitle) && (
                    <div className="mb-5 md:mb-10">
                        {sectionTitle && (
                            <h2
                                className={`text-center mb-5`}
                                // eslint-disable-next-line react/no-danger
                                dangerouslySetInnerHTML={{ __html: renderSanitizedHtmlContent(sectionTitle) }}
                            />
                        )}
                        {sectionSubTitle && (
                            <p
                                className={`text-center text-md lg:text-2xl leading-relaxed tracking-tight6 font-light`}
                                // eslint-disable-next-line react/no-danger
                                dangerouslySetInnerHTML={{ __html: renderSanitizedHtmlContent(sectionSubTitle) }}
                            />
                        )}
                    </div>
                )}
                <div
                    className={`card-wrapper rounded md:rounded-sm overflow-hidden shadow-xxlMedium md:flex bg-no-repeat bg-right-center bg-contain ${cardColorMapping?.bgColor} ${styles.bgImage}`}
                    style={backgroundImage ? { backgroundImage: `url(${backgroundImage?.[0]?.secure_url})` } : null}
                >
                    <div
                        className={`flex flex-col justify-between md:w-7/12 px-5 pt-10 pb-5 md:p-8 lg:p-12 lg:pr-9 lg:pt-12 rounded-b md:rounded-br-none md:rounded-l-sm`}
                    >
                        {/* Render title if it exists */}
                        <div className="cardContent">
                            {title && (
                                <h3 className={`title-3 lg:title-2 text-white lg:text-white text-xl mb-5`}>{title}</h3>
                            )}

                            {/* Render description if it exists */}
                            {description?.description && (
                                <p
                                    className={`${cardColorMapping?.primaryTextColor} text-md lg:text-2xl font-light leading-relaxed`}
                                >
                                    {description.description}
                                </p>
                            )}
                        </div>
                        {/* Render cta if it exists */}
                        {cta && (
                            <div className="col-12 mt-3.5 md:mt-3.75 flex gap-4 justify-start flex-wrap">
                                {cta.map((button) => (
                                    <Cta key={button.id} data={button} className="tracking-normal" />
                                ))}
                            </div>
                        )}
                    </div>
                    <div
                        className={`md:w-5/12 md:relative md:flex-none bg-white rounded md:rounded-sm mx-5 mt-10 mb-5 md:m-8 lg:m-12 lg:ml-0 lg:mt-12 px-10 py-1 md:py-0`}
                    >
                        {/* Render body if it exists */}
                        {body && <RichText data={cardItem} className={`${styles.bodyContent}`} />}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default PricingPromo;
